import React, { useEffect, useState } from 'react'
import DisabilityComplaintModalUi from './DisabilityComplaintModalUi';
import { disabilityComplaintFetchByIdApi } from '../../apis/disabilityComplaint.api';
import { callApiAction } from '../../store/actions/commonAction';
import { useDispatch } from 'react-redux';

const DisabilityComplaintModalController = ({ id }) => {
    const [data, setData] = useState({})
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch()

    console.log("object id modal", id);
    const fetchByIdDisability = (id) => {
        setLoading(true);
        dispatch(
            callApiAction(
                async () => await disabilityComplaintFetchByIdApi({ id }),
                async (response) => {
                    setData({...response});
                    console.log(" data and object", ...response);
                    setLoading(false);
                },
                (err) => {
                    setData({ ...data, err });
                    setLoading(false);
                }
            )
        );
    };

    useEffect(() => {
        if (id) fetchByIdDisability(id);
    }, [id]);

    return (
        <DisabilityComplaintModalUi
            id={id}
            data={data}
            setData={setData}
            loading={loading}
        />
    )
}

export default DisabilityComplaintModalController